/**
 * boost-sealed-offer-extension.js
 * Safely intercepts Boost Commerce's product grid rendering to inject the Sealed Offer Event UI.
 */
(function() {
  function initBoostInterceptor() {
    if (typeof ProductGridItem !== 'undefined' && typeof ProductGridItem.prototype.compileTemplate === 'function') {
      
      var originalCompileTemplate = ProductGridItem.prototype.compileTemplate;
      
      ProductGridItem.prototype.compileTemplate = function (data, index) {
        if (!data) data = this.data;
        if (!index) index = this.index;
        
        // 1. Let Boost compile the standard HTML first
        var html = originalCompileTemplate.call(this, data, index);
        
        // 2. Determine if product is a Sealed Offer or Dummy Package
        var tags = data.tags || [];
        var isSealedOffer = false;
        var hasPackageTag = false;
        var offerEndDate = '';
        
        tags.forEach(function(tag) {
          var t = tag.toLowerCase().trim();
          if (t === 'sealed offer event') isSealedOffer = true;
          if (t === 'equipment package' || t === 'part of package') hasPackageTag = true;
          if (t.indexOf('offer ends') > -1 || t.indexOf('sale ends') > -1) {
            var parts = t.split('ends');
            if (parts.length > 1) {
              var clean = parts[1].replace(':', '').trim();
              if (clean.charAt(0) === '-' || clean.charAt(0) === '–' || clean.charAt(0) === '—') {
                clean = clean.substring(1).trim();
              }
              offerEndDate = clean;
            }
          }
        });
        
        var variantPrice = data.price_min || 0;
        var comparePrice = data.compare_at_price_min || 0;
        
        var isExpired = false;
        var prettyDate = offerEndDate;
        if (offerEndDate) {
          // Parse as end of day local time to ensure full day availability
          var d = new Date(offerEndDate + 'T23:59:59');
          if (!isNaN(d.getTime()) && new Date() > d) {
            isExpired = true;
          }
          
          var dateParts = offerEndDate.split('-');
          if (dateParts.length === 3) {
            var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var mIndex = parseInt(dateParts[1], 10) - 1;
            if (mIndex >= 0 && mIndex <= 11) {
              prettyDate = monthNames[mIndex] + ' ' + parseInt(dateParts[2], 10) + ', ' + dateParts[0];
            }
          }
        }
        
        // 3. Evaluate Dummy Package status
        var inventoryQuantity = 0;
        if (data.variants && data.variants.length > 0) {
          for (var i = 0; i < data.variants.length; i++) {
            inventoryQuantity += parseInt(data.variants[i].inventory_quantity, 10) || 0;
          }
        }
        var isOneDollar = (variantPrice === 100 || variantPrice === 1 || variantPrice === 1.00 || variantPrice === "1" || variantPrice === "1.00" || variantPrice === "100");
        var isDummyPackageItem = (hasPackageTag && isOneDollar && inventoryQuantity <= 0);

        // 4. If criteria met, manipulate the compiled HTML
        if (isSealedOffer && comparePrice > variantPrice) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          
          // Find the main product card wrapper. Note: some themes wrap the item in an outer div.
          // We will search for product-item and manipulate it.
          var itemDiv = doc.querySelector('.product-item');
          if (!itemDiv) return html; // fallback if class is missing
          
          // A. Replace the Save Badge
          var saleLabel = itemDiv.querySelector('.product-label--on-sale');
          if (saleLabel) {
            var badgeText = isExpired ? 'Sealed Offer Event Ended' : 'Sealed Offer Event';
            saleLabel.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="11" height="11" fill="currentColor" style="position: relative; top: -1px; margin-right: 6px;"><path d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"/></svg>' + badgeText;
            if (isExpired) {
              saleLabel.style.backgroundColor = '#666'; // Gray out if ended
            }
            saleLabel.style.display = 'inline-flex';
            saleLabel.style.alignItems = 'center';
            saleLabel.style.letterSpacing = '0.05em';
          }
          
          // B. Replace the Price
          var priceHighlight = itemDiv.querySelector('.price--highlight');
          if (priceHighlight) {
            if (isExpired) {
              priceHighlight.innerHTML = '<span style="font-weight: bold; font-size: 1.2em; color: var(--text-color);">OFFER ENDED</span>';
            } else {
              var testOutput = typeof Utils !== 'undefined' && Utils.formatMoney ? Utils.formatMoney(100) : '100';
              var isCents = testOutput.replace(/[^0-9]/g, '') === '100';
              var step = isCents ? 50000 : 500;
              
              var sliderMinRaw = (variantPrice * 0.55);
              var sliderMinRounded = Math.round(sliderMinRaw / step) * step;
              if (sliderMinRounded < step) sliderMinRounded = step;
              
              var formattedMin = typeof Utils !== 'undefined' && Utils.formatMoney 
                ? Utils.formatMoney(sliderMinRounded) 
                : '$' + (sliderMinRounded / (isCents ? 100 : 1)).toLocaleString();
              
              formattedMin = formattedMin.replace(/\.00$/, ''); // strip .00 if needed
              priceHighlight.innerHTML = '<span style="display: block; font-size: 0.65em; font-weight: normal; color: var(--text-color); opacity: 0.7; line-height: 1.1; margin-bottom: 2px;">Offers starting at</span>' + formattedMin;
            }
            
            var priceCompare = itemDiv.querySelector('.price--compare');
            if (priceCompare) priceCompare.remove();
          }
          
          // C. Replace the Inventory Count with End Date
          var inventoryEl = itemDiv.querySelector('.product-item__inventory');
          if (isExpired) {
            if (inventoryEl) inventoryEl.remove();
          } else if (offerEndDate) {
            var dateHtml = '<div style="font-size: 14px; text-align: center; margin-top: 8px; line-height: 1.2;"><span style="color: var(--text-color-light); display: block;">Offers Accepted Until:</span><strong>' + prettyDate + '</strong></div>';
            
            if (inventoryEl) {
              inventoryEl.outerHTML = dateHtml;
            } else {
              var infoInner = itemDiv.querySelector('.product-item__info-inner');
              if (infoInner) infoInner.insertAdjacentHTML('beforeend', dateHtml);
            }
          } else if (inventoryEl) {
            inventoryEl.remove();
          }
          
          // D. Replace "Add to Cart" with "Make an Offer"
          // In the theme, this is inside .product-item__action-list form
          var actionList = itemDiv.querySelector('.product-item__action-list');
          if (actionList) {
            var addToCartBtn = actionList.querySelector('button[data-action="add-to-cart"], .button--primary');
            var btnClasses = addToCartBtn ? addToCartBtn.className : 'product-item__action-button button button--small button--primary';
            
            if (isExpired) {
              // Remove entirely and show message + View Listing button
              actionList.innerHTML = '<div style="text-align: center; font-size: 13px; color: var(--text-color-light); margin-bottom: 12px; padding: 0 10px; line-height: 1.4;">The winning offer will be contacted soon with more details.</div>' +
                                     '<button type="button" class="' + btnClasses + '" style="margin-bottom: 10px;" onclick="window.location.href=\'/products/' + data.handle + '\'">View Listing</button>';
            } else {
              // Find Add to Cart button to copy its exact classes
              var addToCartBtn = actionList.querySelector('button[data-action="add-to-cart"], .button--primary');
              var btnClasses = addToCartBtn ? addToCartBtn.className : 'product-item__action-button button button--small button--primary';
              
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = btnClasses;
              btn.innerText = 'Make an Offer';
              btn.style.marginBottom = '10px';
              btn.setAttribute('onclick', "window.location.href='/products/" + data.handle + "'");
              
              // Find Add to Cart button and replace it, keeping Quick View
              if (addToCartBtn) {
                addToCartBtn.parentNode.replaceChild(btn, addToCartBtn);
              } else {
                actionList.insertBefore(btn, actionList.firstChild);
              }
              
              // Clean up mobile buttons if they exist
              var oldMobileBtn = actionList.querySelector('.hidden-tablet-and-up');
              if (oldMobileBtn && oldMobileBtn !== btn) {
                oldMobileBtn.remove(); // we'll just let the new link button handle all views since it's a standard link
                btn.classList.remove('hidden-phone');
              }
            }
          }
          
          // Return the modified HTML string
          return doc.body.innerHTML;
        } else if (isDummyPackageItem) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          
          var itemDiv = doc.querySelector('.product-item');
          if (!itemDiv) return html;
          
          // A. Replace the Price
          var priceList = itemDiv.querySelector('.product-item__price-list') || itemDiv.querySelector('.price-list');
          if (priceList) {
            priceList.innerHTML = '<span class="price price--highlight" style="text-transform: none;">Part of Package</span>';
          }
          
          // B. Remove the "Add to Cart" / "Sold Out" Button (keeping quick view)
          var actionList = itemDiv.querySelector('.product-item__action-list');
          if (actionList) {
            var addToCartBtn = actionList.querySelector('button[data-action="add-to-cart"], .button--disabled');
            if (addToCartBtn) {
              addToCartBtn.remove();
            }
          }
          
          return doc.body.innerHTML;
        }
        
        return html;
      };
      
    } else {
      // If Boost hasn't loaded yet, try again in 50ms
      setTimeout(initBoostInterceptor, 50);
    }
  }
  
  // Start trying to inject
  initBoostInterceptor();
})();
